import Vue from 'vue'
import ViewUI from 'view-design'



Vue.use(ViewUI,{
    transfer: true,
    size: 'large',
    capture: false,
    select: {
        arrow: 'md-arrow-dropdown',
        arrowSize: 20
    }
})

import 'view-design/dist/styles/iview.css'
